import { ADVISOR_SESSION_FRAGMENT } from '@src/gql/fragments/AdvisorSessionFragment'
import { gql } from '@src/lib/gql'

export const UPSERT_RATING = gql`
  mutation UpsertRating($input: UpsertRatingInput!) {
    upsertRating(input: $input) {
      rating {
        id
        ratingId
        score
        note
        rateableType
        rateableId
      }
      advisorSession {
        ...AdvisorSessionFragment
      }
    }
  }
  ${ADVISOR_SESSION_FRAGMENT}
`
